import React, { useState, useEffect } from 'react';
import classes from "./form.module.css"
import InputField from "../../../containers/inputField/inputField";
import { sixYardAxios } from '../../../../sixYardAxios';
import PromptMessage from "../../../containers/promptMessage/promptMessage";

const Form = (props) => {
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [loading, setLoading] = useState(false);
    const [controls, setControls] = useState({
        companyName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter name" : "أدخل الاسم",
            },
            value: "",
            validation: {
                required: true,
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Company Name" : "اسم الشركة",
            valid: false,
            touched: false
        },
        guestNumber: {
            elementType: "input",
            elementConfig: {
                type: "number",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter number" : "أدخل العدد",
                min: "1",
            },
            value: "",
            validation: {
                required: true,
                isNumeric: true
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Guests Number" : "عدد الضيوف",
            valid: false,
            touched: false
        },
        date: {
            withIcon: true,
            elementType: "input",
            elementConfig: {
                type: "calendarDate",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Select date" : "اختر التاريخ",
            },
            availableDates: props.availableSlots,
            value: "",
            validation: {
                required: true,
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Date" : "التاريخ",
            valid: false,
            touched: false
        },
        time: {
            elementType: "select",
            elementConfig: {
                type: "text",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Select time" : "اختر الوقت",
                options: []
            },
            value: "",
            validation: {
                required: true,
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Time" : "الوقت",
            valid: false,
            touched: false
        },
        yourName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter name" : "أدخل الاسم",
            },
            value: "",
            validation: {
                required: true,
                minLength: 6,
                maxLength: 32,
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Your Name" : "اسمك",
            valid: false,
            touched: false
        },
        email: {
            elementType: "input",
            elementConfig: {
                type: "email",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter email" : "أدخل البريد الإلكتروني",
            },
            value: "",
            label: parseInt(localStorage.getItem('language')) === 1 ? "Email" : "البريد الإلكتروني",
            validation: {
                required: true,
                isEmail: true
            },
            valid: false,
            touched: false
        },
        phone: {
            elementType: "input",
            elementConfig: {
                type: "phone",
                placeholder: "07xxxxxxxx",
            },
            value: "",
            valueName: "phone_number",
            validation: {
                required: true,
                isNumeric: true,
                minLength: 10,
                maxLength: 10
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Phone" : "رقم الهاتف",
            valid: false,
            touched: false
        },
        specialRequests: {
            elementType: "textarea",
            elementConfig: {
                type: "textarea",
                placeholder: parseInt(localStorage.getItem('language')) === 1 
                    ? "Enter your requests in details" 
                    : "أدخل طلباتك بالتفصيل",
            },
            value: "",
            label: parseInt(localStorage.getItem('language')) === 1 ? "Special Requests" : "طلبات خاصة",
            valid: false,
            touched: false,
        },
    });

    useEffect(() => {
        const updatedControls = {
            ...controls,
            date: {
                ...controls.date,
                availableDates: props.availableSlots

            }
        };
        setControls(updatedControls);
    }, [props.availableSlots]);

    useEffect(() => {
        controls.date.value.length > 0 && handleDateSelection(controls.date.value)
    }, [controls.date.value]);

    const formElementsArray = [];
    for (let key in controls) {
        formElementsArray.push({
            id: key,
            config: controls[key]
        });
    }
    const form = formElementsArray.map((formElement, i) => (
        <div key={i} className={[classes.FormGroup, formElement.id === "date" && classes.FormGroupCalendar].join(" ")}>
            <InputField
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                availableDates={formElement.config.availableDates}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                withRemove={false}
                withIcon={formElement.config.withIcon}
                label={formElement.config.label}
                changed={event => inputChangedHandler(event, formElement.id)}
            />
        </div>
    ));
    const checkValidity = ((value, rules) => {
        let isValid = true;
        if (!rules) {
            return true;
        }

        if (rules.required) {
            value = typeof value === 'string' ? value.trim() : value;
            isValid = value !== "" && isValid;
        }

        if (rules.minLength) {
            isValid = value?.length >= rules.minLength && isValid;
        }

        if (rules.maxLength) {
            isValid = value?.length <= rules.maxLength && isValid;
        }

        if (rules.isEmail) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test(value) && isValid;
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid;
        }

        return isValid;
    })
    // Handle date selection
    const handleDateSelection = (selectedDate) => {
        const selectedSlots = props.availableSlots.find(
            (slot) => slot.date === selectedDate[0]
        );
        // Update time options
        const updatedOptions = selectedSlots
            ? selectedSlots.slots.map((slot) => ({
                value: slot.time,
                displayValue: slot.time,
            }))
            : [];
        const updatedControls = {
            ...controls,
            time: {
                ...controls.time,
                elementConfig: {
                    ...controls.time.elementConfig,
                    options: updatedOptions
                }
            }
        };
        setControls(updatedControls);
    };
    const inputChangedHandler = (event, controlName) => {
        const value = controlName === "phone" || controlName === "date" ? event : event.target.value;
        const updatedControls = {
            ...controls,
            [controlName]: {
                ...controls[controlName],
                value,
                valid: checkValidity(value, controls[controlName].validation),
                touched: true
            }
        };
        setControls(updatedControls);
    };
    const clearControls = () => {
        const updatedControls = {
            ...controls
        };
        for (let key in controls) {
            updatedControls[key] = {
                ...controls[key],
                value: "",
                valid: false,
                touched: false
            };
        }
        setControls(updatedControls);
    };
    const submitHandler = async (e) => {
        e.preventDefault();
        if (!props.isAuthenticated) props.setShowLoginForm(true)
        else {
            setError(null);
            setLoading(true);

            try {
                const formData = {
                    type_id: 2,
                    selected_activities: props.selectedActivities,
                    food_items: props.selectedFood,
                    participants_count: controls.guestNumber.value,
                    date: controls.date.value[0],
                    time_slot: controls.time.value,
                    special_requests: controls.specialRequests.value,
                    contact_details: {
                        email: controls.email.value,
                        phone: controls.phone.value.dialCode + controls.phone.value.number,
                        company_name: controls.companyName.value,
                        name: controls.yourName.value
                    },
                    event_details: "Team building event",
                };
                const response = await sixYardAxios.post('/activities/book', formData);
                if (response.data.data) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    clearControls();
                    setSuccess(response.data.data.message);
                }
            } catch (err) {
                setError(err.response?.data?.message || 'Something went wrong. Please try again.');
            } finally {
                setLoading(false);
            }
        }
    };
    return (
        <form className={classes.Container} onSubmit={(e) => submitHandler(e)}>
            {form}
            <p className={classes.Prompt}>
                {parseInt(localStorage.getItem('language')) === 1 
                    ? "Please read and agree to our "
                    : "يرجى قراءة والموافقة على "}
                <a href="/privacy-policy" target='_blank' className={classes.Link}>
                    {parseInt(localStorage.getItem('language')) === 1 
                        ? "Privacy Policy "
                        : "سياسة الخصوصية "}
                </a>
                {parseInt(localStorage.getItem('language')) === 1 ? "and " : "و "}
                <a href="/terms-and-conditions" target='_blank' className={classes.Link}>
                    {parseInt(localStorage.getItem('language')) === 1 ? "Terms" : "الشروط"}
                </a>
            </p>
            <div className={classes.CheckBox}>
                <input type="checkbox" onClick={() => setIsTermsChecked(!isTermsChecked)} />
                <label className={classes.Label}>
                    {parseInt(localStorage.getItem('language')) === 1 
                        ? "I have read and agreed to terms and conditions and privacy policy"
                        : "لقد قرأت ووافقت على الشروط والأحكام وسياسة الخصوصية"}
                </label>
            </div>
            <div>
                <button type="submit" 
                    className={[classes.submitButton, !isTermsChecked && classes.Disabled].join(" ")}
                    disabled={!isTermsChecked}
                >
                    {parseInt(localStorage.getItem('language')) === 1 ? "SUBMIT" : "إرسال"}
                    <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/b4d5bcaf1ebb966f9c466b88bc4db272a664766c03afdc1eeb10bad706c68a4a?placeholderIfAbsent=true&apiKey=55c20a0273674f7297318d8ed49e9ee9"
                        alt=""
                        className={classes.submitIcon}
                    />
                </button>
            </div>
            {error && <PromptMessage 
                message={error} 
                status={parseInt(localStorage.getItem('language')) === 1 ? 'Oops' : 'عفواً'} 
                button={parseInt(localStorage.getItem('language')) === 1 ? 'CLOSE' : 'إغلاق'} 
                click={() => setError(false)} 
            />}
            {success && <PromptMessage 
                message={success} 
                status={parseInt(localStorage.getItem('language')) === 1 ? 'CONGRATULATIONS' : 'تهانينا'} 
                successMessage 
                button={parseInt(localStorage.getItem('language')) === 1 ? 'CLOSE' : 'إغلاق'} 
                click={() => setSuccess(false)} 
            />}
        </form>
    )
}
export default Form;